import { Instagram } from "lucide-react";
import { INSTAGRAM_URL, TIKTOK_URL } from "@/data/catalog";

export const TikTokIcon = ({ size = 16 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" aria-hidden>
    <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 1 1-2.31-2.83V9.34a6.34 6.34 0 1 0 5.76 6.31V8.73a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.16z" />
  </svg>
);

const socialIconClass =
  "flex h-10 w-10 items-center justify-center rounded-full border border-white/10 text-white/60 transition-colors duration-300 hover:border-[#cba153] hover:text-[#cba153]";

const SocialButtons = ({ testIdPrefix = "social" }) => (
  <>
    <a
      href={INSTAGRAM_URL}
      target="_blank"
      rel="noopener noreferrer"
      data-testid={`${testIdPrefix}-instagram-link`}
      aria-label="Instagram"
      className={socialIconClass}
    >
      <Instagram size={16} />
    </a>
    <a
      href={TIKTOK_URL}
      target="_blank"
      rel="noopener noreferrer"
      data-testid={`${testIdPrefix}-tiktok-link`}
      aria-label="TikTok"
      className={socialIconClass}
    >
      <TikTokIcon size={15} />
    </a>
  </>
);

export default SocialButtons;
